import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Tiplist} from 'shared/models/tips/tiplist';

@Injectable()
export class TipListDetailsRepository {

  constructor(private http: Http) { }

  public getTiplistById(id: string): Observable<Tiplist> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});
    return this.http.get(`${environment.tiplists}/${id}?withRating=true`, options)
      .map((tiplist: Response) => {
        return tiplist.json();
      });
  }

  public saveTiplist(tiplist: Tiplist): Observable<Tiplist> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify(tiplist);

    return this.http.post(environment.tiplists, body, options)
      .map((createdTiplist: Response) => {
        return createdTiplist.json();
      });
  }

  public updateTiplist(tiplist: Tiplist): Observable<Tiplist> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify(tiplist);

    return this.http.put(`${environment.tiplists}/${tiplist._id}`, body, options)
      .map((updatedTiplist: Response) => {
        return updatedTiplist.json();
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/tip-list/tip-list-details/repositories/tip-list-details.repository.ts